import React, { Component } from 'react';
import { Nav, Navbar, NavDropdown, NavItem } from 'react-bootstrap';
import {INQUIRY_SUPPORT_URL, FAQ_URL } from '../constants';
import { HIDDEN_STATUS } from '../constants/EnterpriseConstants';
import ItemList from '../components/ItemList';
import $ from 'jquery';
import { ROOT_URL } from '../constants/index';
import * as Path from '../constants/PathConstants';
import * as FUNCTION from '../constants/FunctionConstants';
import * as ICON from '../constants/IconConstants';
import { CONTENT_TYPE_STR } from "../constants/ContentConstant";
import { isSuperUser } from '../utils/index';
import store from '../store';
import ExpandImage from '../images/icon_collapse.svg';
import CollapseImage from '../images/icon-double-left-arrow.png';
import DoubleArrowLeft from '../images/doubleArrowLeft.svg';
import DoubleArrowRight from '../images/doubleArrowRight.svg';


function LeftNavigator(props) {
  const {
    leftNavigatorDatas,
    url,
    logout,
    rightMenuTitle,
    isTrialExpire,
    isShowContract,
    hideTopMenu,
    showContentsOnly,
    displayUserType,
    hiddenStatus,
    showMenu,
    isCollapsedMode,
    collapsibleMenu,
    mouseEnterLeftMenu,
    mouseLeaveLeftMenu,
    history,
  } = props;
  const { serviceCd } = store.getState().authed.authedUser;
  const menu = leftNavigatorDatas.map((itemData) => {
    const { id, path } = itemData;
    const isShowContentMenu =
      url === Path.CONTENT_LIST ||
      url.indexOf(Path.GENERAL_CONTENT_VIDEO) > -1 ||
      url.indexOf(Path.GENERAL_CONTENT_DOCUMENT) > -1 ||
      url.indexOf(Path.GENERAL_CONTENT_LINK) > -1 ||
      url.indexOf(Path.GENERAL_CONTENT_MULTILANGUAGE) > -1;

    const isShowDrillMenu =
      url === Path.CONTENT_LIST ||
      url.indexOf(Path.GENERAL_CONTENT_DRILL) > -1 ||
      url.indexOf(Path.GENERAL_CONTENT_SKIN) > -1 ||
      url.indexOf(Path.GENERAL_CONTENT_QUESTION) > -1;
    // Step 9.0.1 START
    if (itemData.id === FUNCTION.LOGOUT) {
      return <ItemList data={itemData} logout={logout} />;
    }
    // Step 9.0.1 END
    if (hideTopMenu && !showContentsOnly) {
      return null;
    }
    // path: url of item left menu
    // url: input from address bar
    if (hideTopMenu) {
      if (
        showContentsOnly === CONTENT_TYPE_STR.DRILL &&
        path === Path.CONTENT_DRILL_LIST &&
        isShowDrillMenu
      ) {
        return <ItemList key={id} data={itemData} url={url} />;
      } else if (
        showContentsOnly !== CONTENT_TYPE_STR.DRILL &&
        (path === Path.CONTENT_VIDEO_LIST || path === Path.CONTENT_DOCUMENT_LIST )&&
        isShowContentMenu
      ) {
        return <ItemList key={id} data={itemData} url={url} />;
      }
      return null;
    } else {
      return (<ItemList key={id} data={itemData} url={url} history={history} history={history}/>);
    }
  });
  const accountEdit = {
    title: 'アカウント管理',
    path: Path.ACCOUNT_EDIT,
    id: FUNCTION.ACCOUNT_EDIT,
    icon: ICON.KEY,
  }
  if(hideTopMenu){
    return(
      <div className="left-navigator z-index-1000">
        <Navbar collapseOnSelect> 
        </Navbar>
        <ul className="menu-list">
        {menu}
        </ul>
        <div className="btn-tutorial">
        </div>
        <div className="inquiry-region padding-left-right-clear">
        </div>
      </div>
    );
  }

  return (
    <div
      className={`${!!serviceCd ? "" : "left-navigator-superuser"}`}
      onMouseEnter={mouseEnterLeftMenu}
      onMouseLeave={mouseLeaveLeftMenu}
    >
      <div className="z-index-1000">
        {/* STEP9.0.1 START */}
        <div
          className={
            `collapse-expand` +
            `${showMenu ? " collapse-button" : " expand-button"}`
          }
        >
          {/* Step 11.0.0 START */}
          {showMenu && <div id="rightmenu_DROPDOWN">{rightMenuTitle}</div>}
          {/* Step 11.0.0 END */}
          <button onClick={collapsibleMenu}>
            {showMenu && (
              <img
                src={isCollapsedMode ? DoubleArrowRight : DoubleArrowLeft}
                alt="Double arrow button"
              />
            )}
            {!showMenu && <img src={ExpandImage} alt="Expand button" />}
          </button>
        </div>
        <div
          className={
            `left-navigator z-index-1000` +
            `${!showMenu ? " collapse-menu" : " expand-menu"}`
          }
        >
          {/* STEP9.0.1 END */}
          {showMenu && <ul className="menu-list">{menu}</ul>}
        </div>
      </div>
    </div>
  );
};

function openHint() {
  const newPage = window.open(ROOT_URL.concat('/hint'),
  'Hint', 'height=717,width=1020,menubar=no,toolbar=no,scrollbars=yes,resizable=no');
  newPage.focus();
}

function openInquiry() {
  const newPage = window.open(`${INQUIRY_SUPPORT_URL}`, '_blank');
  newPage.focus();
}

function openFaqPage() {
  const newPage = window.open(`${FAQ_URL}`, '_blank');
  newPage.focus();
}


function handleMouseEnter(event) {
  const target = event.target.id;
  if (!target &&
     !$(event.target).closest('a').closest('li').hasClass('dropdown')) {
    $(event.target).closest('a').closest('li').addClass('dropdown');
  }
  if (target) {
    if (!$(`#${target}`).closest('li').hasClass('dropdown')) {
      $(`#${target}`).closest('li').addClass('dropdown');
    }
  }
}

export default LeftNavigator;
